import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'insurance'

const InsuranceModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default InsuranceModule



// WEBPACK FOOTER //
// ./src/store/module/insurance/index.js